var _filter, _linearGradient, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableTennis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Ui-root css-2qgrgz",
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: ":r1l:-filter",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 20.543,
    width: 19.9944,
    x: 2,
    y: 2
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2978_44220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2978_44220",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r1l:-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 3,
    x2: 20.4941,
    y1: 4.4773,
    y2: 20.7126
  }, /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.473958,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.474058,
    stopColor: "#ffdb00",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#:r1l:-filter)",
    className: "Ui-outlineFilter"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    d: "m10.667 17.3878c-.82652-.0136-1.95918.1122-2.73129.7687l-1.82262 2.0507c-.38225.4301-1.0477.4497-1.45457.0428l-.86711-.8671c-.40697-.407-.38726-1.0726.04308-1.4548l2.06381-1.8329c.86394-1.0272.79252-2.6802.71088-3.4115zm-5.96598-14.3878c-.93946 0-1.70102.76156-1.70102 1.70102s.76156 1.70068 1.70102 1.70068 1.70068-.76156 1.70068-1.70068c0-.93911-.76156-1.70102-1.70068-1.70102zm7.36398 14.1473c2.2568 1.12 4.3952.0357 6.3823-1.9514 2.9251-2.9248 3.6415-6.95134.4962-10.09692-3.1452-3.14456-7.1724-2.42891-10.0969.4966-1.98708 1.98571-3.01225 4.14558-1.95136 6.38202z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.667 17.3878c-.82652-.0136-1.95918.1122-2.73129.7687l-1.82262 2.0507c-.38225.4301-1.0477.4497-1.45457.0428l-.86711-.8671c-.40697-.407-.38726-1.0726.04308-1.4548l2.06381-1.8329c.86394-1.0272.79252-2.6802.71088-3.4115zm-5.96598-14.3878c-.93946 0-1.70102.76156-1.70102 1.70102s.76156 1.70068 1.70102 1.70068 1.70068-.76156 1.70068-1.70068c0-.93911-.76156-1.70102-1.70068-1.70102zm7.36398 14.1473c2.2568 1.12 4.3952.0357 6.3823-1.9514 2.9251-2.9248 3.6415-6.95134.4962-10.09692-3.1452-3.14456-7.1724-2.42891-10.0969.4966-1.98708 1.98571-3.01225 4.14558-1.95136 6.38202z",
    fill: "url(#:r1l:-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Ui-outline",
    d: "m10.6588 17.8877c.197.0032.3775-.1095.4611-.288.0835-.1785.0544-.3893-.0743-.5385l-1.41989-1.6461 2.08569 2.0857c.0384.0384.0827.0702.1313.0944 1.2589.6247 2.4993.6341 3.6824.2126 1.1639-.4147 2.257-1.2396 3.2757-2.2583 1.5259-1.5257 2.5053-3.3682 2.6692-5.2765.165-1.92238-.5033-3.85776-2.1729-5.52755v-.00006c-1.6697-1.66928-3.6051-2.33755-5.5276-2.17256-1.9083.1638-3.751 1.14316-5.27652 2.66926-2.03142 2.0301-3.25139 4.41611-2.04949 6.94971.00274.0058.00558.0115.00854.0172-.01441.0048-.0287.0102-.04283.0164-.20087.0877-.32124.2959-.29693.5137.03843.3443.07315.8974 0 1.4768-.07229.5725-.244 1.1232-.57478 1.5311l-2.03502 1.8072c-.64551.5733-.67507 1.5718-.06461 2.1823l.86711.8671c.61031.6103 1.60848.5809 2.18185-.0642l1.79805-2.0231c.62685-.5148 1.58388-.6416 2.37393-.6286zm-5.95778-15.3877c-1.2156 0-2.20102.98542-2.20102 2.20102 0 1.21573.98555 2.20068 2.20102 2.20068 1.21566 0 2.20068-.98549 2.20068-2.20068 0-1.21513-.98529-2.20102-2.20068-2.20102z",
    stroke: "#5800e9",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTennis);
export default __webpack_public_path__ + "static/media/table-tennis.526ab42c8abc8c07f7c9e0d424a90279.svg";
export { ForwardRef as ReactComponent };